/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { componentPropType } from 'ggApp/types/propTypes';
import withCheckoutTransitionGuard from 'ggApp/shared/hocs/withCheckoutTransitionGuard';
import { RouterComponent_LinkWithStore as Link } from 'ggApp/modules/router';

const ProceedButton = ({ className, onClick, disabled, component: Button, ...restProps }) => (
    <Link to={!disabled && '/checkout'} onClick={!disabled && onClick}>
        <Button {...restProps} disabled={disabled} />
    </Link>
);

ProceedButton.propTypes = {
    component: componentPropType.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

ProceedButton.defaultProps = {
    className: '',
};

export default withCheckoutTransitionGuard(ProceedButton);
